import styled, { css } from 'styled-components';
import { media } from '@styles/breakpoints';

type ContainerWidth = 'default' | 'narrow' | 'wide' | 'fluid';

const widthMap: Record<ContainerWidth, string> = {
  narrow: '840px',
  default: '1280px',
  wide: '1440px',
  fluid: '100%',
};

export const Container = styled.div<{ $width?: ContainerWidth }>`
  width: 100%;
  max-width: ${({ $width = 'default' }) => widthMap[$width]};
  margin-inline: auto;
  padding-inline: ${({ theme }) => theme.spacing[5]};

  ${media.tablet} {
    padding-inline: ${({ theme }) => theme.spacing[8]};
  }

  ${media.desktop} {
    padding-inline: ${({ theme }) => theme.spacing[12]};
  }

  ${({ $width }) =>
    $width === 'fluid' &&
    css`
      max-width: none;
      padding-inline: 0;
    `}
`;
